import {Card,Icon,Menu,Select,SelectChangeEvent,Typography,InputLabel,MenuItem,FormControl,TextField,Button,Alert,Link,Box,Container,Grid,Dialog,DialogTitle,DialogContent,DialogActions,IconButton} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import {  toast } from 'react-toastify';
import 'assets/style/style.css';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useParams, useNavigate } from 'react-router-dom';
import { useMaterialUIController, setOrderContext } from "context";
// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import DataTable from "layouts/Tables/DataTable";

import Config from "config.js";
import { useEffect, useState, useContext } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { handleErrors } from "common.js";
function List() {

  const [controller, dispatch, initialState]           = useMaterialUIController();
  const { orderContext, paginationSize } = controller;


  const orderBy       = orderContext.orderBy;
  const orderByType   = orderContext.orderByType;
  const filterBy      = orderContext.filterBy;
  const searchBy      = orderContext.searchBy;
  const paymentStatus = orderContext.paymentStatus;
  const orderStatus   = orderContext.orderStatus;
  const timePeriod    = orderContext.timePeriod;
  const searchByValue = orderContext.searchByValue;

  const [isOrderContextChanged, setOrderContextChanged] = useState(false);


  const navigate   = useNavigate();

  const { pageNo } = useParams();

  var pageSelected     = 1;

  if(typeof pageNo !== "undefined")
  {
      const parts  = pageNo.split("-");
      pageSelected = parts[1].trim(); 
  }
    
  const { t } = useTranslation();

  const baseUrl  = Config.baseUrl;
  const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;
  const [isLoading, setIsLoading] = useState(false);
  const [dataTableData, setDataTableData] = useState({});
  const [responseResultCount, setResponseResultCount] = useState(0);


  useEffect(() => {

    listOrders();

  }, [pageNo]);
   


  const handleChangeOrderBy = (event: SelectChangeEvent) => {
    setOrderContext(dispatch, { ...orderContext, orderBy: event.target.value});
  };

  const handleChangeOrderByType = (event: SelectChangeEvent) => {
    setOrderContext(dispatch, { ...orderContext, orderByType: event.target.value});
  }; 

  const handleChangeFilterBy = (event: SelectChangeEvent) => {
    setOrderContext(dispatch, { ...orderContext, 
      filterBy: event.target.value,
      paymentStatus: 'all',
      orderStatus: 'all',
      timePeriod: 'all',  
    });
  };
  const handleChangePaymentStatus = (event: SelectChangeEvent) => {
    setOrderContext(dispatch, { ...orderContext, paymentStatus: event.target.value});
  };

  const handleChangeOrderStatus = (event: SelectChangeEvent) => {
    setOrderContext(dispatch, { ...orderContext, orderStatus: event.target.value});
  };

  const handleChangeTimePeriod = (event: SelectChangeEvent) => {
    setOrderContext(dispatch, { ...orderContext, timePeriod: event.target.value});
  };
  const handleChangeSearchBy = (event: SelectChangeEvent) => {
    setOrderContext(dispatch, { ...orderContext, 
      searchBy: event.target.value,
      searchByValue: '',      
    });
  };

  const handleChangeSearchByValue = (event) => {
    setOrderContext(dispatch, { ...orderContext, searchByValue: event.target.value});
  };

  const handleKeyPressSearchByValue = (e) => {
    if(searchBy === "orderid" || searchBy === "shopifyorderid")
    {
      // Allow numbers (0-9), backspace, and arrow keys
      if (!/^[0-9\b]+$/.test(e.key)) {
        e.preventDefault();
      }
    }
  };
  
  
    const handleResetFilters = () => {
    setOrderContext(dispatch, initialState.orderContext);
    setOrderContextChanged(false);
    if (typeof pageNo === "undefined")
      navigate("/order/list/page-1");
    else
      navigate("/order/list");
  };

  useEffect(() => {
    const hasChanged = Object.keys(orderContext).some(
      key => orderContext[key] !== initialState.orderContext[key]
    );
    setOrderContextChanged(hasChanged);
  }, [orderContext]);
  

  const renderOrderByList = (
    <>
      <InputLabel>{t('Order By')}</InputLabel>
      <Select
          id="order-by"
          value={orderBy}
          label={t('Order By')}
          onChange={handleChangeOrderBy}
          className='filterStyle'
        >      
        <MenuItem value='orderid'>{t('Order ID')}</MenuItem>
        <MenuItem value='price'>{t('Price')}</MenuItem>
      </Select>      
    </>
  );

  const renderOrderByType = (
    <>
      <InputLabel>{t('order')}</InputLabel>
      <Select
          id="order-by-type"
          value={orderByType}
          label={t('order')}
          onChange={handleChangeOrderByType}
          className='filterStyle'
        >      
        <MenuItem value='desc'>{t('Desc')}</MenuItem>
        <MenuItem value='asc'>{t('Asc')}</MenuItem>
      </Select>      
    </>
  );

  const renderFilterByList = (
    <>
      <InputLabel>{t('Filter By')}</InputLabel>
      <Select
          id="filter-by"
          value={filterBy}
          label={t('Filter By')}
          onChange={handleChangeFilterBy}
          className='filterStyle'
        >      
        <MenuItem value="none">{t('None')}</MenuItem>
        <MenuItem value="payment">{t('Payment Status')}</MenuItem>
        <MenuItem value="order">{t('Order Status')}</MenuItem>
        <MenuItem value="date">{t('Date')}</MenuItem>
      </Select>      
    </>
  );


  const renderPaymentStatusList = (
    <>
      <InputLabel>{t('Payment Status')}</InputLabel>
      <Select
          id="payment-status"
          value={paymentStatus}
          label={t('Payment Status')}
          onChange={handleChangePaymentStatus}
          className='filterStyle'
        >      
        <MenuItem value='all'>{t('All')}</MenuItem>
        <MenuItem value='paid'>{t('Paid')}</MenuItem>
        <MenuItem value='pending'>{t('Pending')}</MenuItem>
        <MenuItem value='refunded'>{t('Refunded')}</MenuItem>
        <MenuItem value='voided'>{t('Voided')}</MenuItem>
      </Select>      
    </>
  );


  const renderOrderStatusList = (
    <>
      <InputLabel>{t('Order Status')}</InputLabel>
      <Select
          id="order-status"
          value={orderStatus}
          label={t('Order Status')}
          onChange={handleChangeOrderStatus}
          className='filterStyle'
        >      
        <MenuItem value='all'>{t('All')}</MenuItem>
        <MenuItem value='open'>{t('Open')}</MenuItem>
        <MenuItem value='accepted'>{t('Accepted')}</MenuItem>
        <MenuItem value='rejected'>{t('Rejected')}</MenuItem>
        <MenuItem value='partially_fulfilled'>{t('Partially Fulfilled')}</MenuItem>
        <MenuItem value='fulfilled'>{t('Fulfilled')}</MenuItem>
      </Select>      
    </>
  );


  const renderTimePeriodList = (
    <>
      <InputLabel>{t('Time Period')}</InputLabel>
      <Select
          id="time-period"
          value={timePeriod}
          label={t('Time Period')}
          onChange={handleChangeTimePeriod}
          className='filterStyle'
        >      
        <MenuItem value='all'>{t('All Time')}</MenuItem>
        <MenuItem value='today'>{t('Today')}</MenuItem>
        <MenuItem value='yesterday'>{t('Yesterday')}</MenuItem>
        <MenuItem value='last7days'>{t('Last 7 Days')}</MenuItem>
        <MenuItem value='last14days'>{t('Last 14 Days')}</MenuItem>
        <MenuItem value='last30days'>{t('Last 30 Days')}</MenuItem>
      </Select>      
    </>
  );

  const renderSearchByList = (
    <>
      <InputLabel>{t('Search By')}</InputLabel>
      <Select
          id="search-by"
          value={searchBy}
          label={t('Search By')}
          onChange={handleChangeSearchBy}
          className='filterStyle'
        >      
        <MenuItem value="none">{t('None')}</MenuItem>
        <MenuItem value="orderid">{t('Order ID')}</MenuItem>
      </Select>      
    </>
  );

  const getPaymentStatusBox = (status) => {
    let paymentStatusBox = '';

    switch (status) {
        case 'pending':
            paymentStatusBox = <Box className="paymentStatusBoxPending">{t(status)}</Box>;
            break;
        case 'refunded':
            paymentStatusBox = <Box className="paymentStatusBoxRefunded">{t(status)}</Box>;
            break;
        case 'voided':
            paymentStatusBox = <Box className="paymentStatusBoxVoided">{t(status)}</Box>;
            break;        
        default:
            paymentStatusBox = <Box className="paymentStatusBoxPaid">{t(status)}</Box>;
            break;
    }

    return paymentStatusBox;
};


const getOrderStatusBox = (status) => {
  let orderStatusBox = '';

  switch (status) {
      case 'open':
          orderStatusBox = <Box className="orderStatusBoxOpen">{t(status)}</Box>;
          break;
      case 'accepted':
          orderStatusBox = <Box className="orderStatusBoxAccepted">{t(status)}</Box>;
          break;
      case 'rejected':
          orderStatusBox = <Box className="orderStatusBoxRejected">{t(status)}</Box>;
          break;      
      case 'partially fulfilled':
          orderStatusBox = <Box className="orderStatusBoxPartiallyFulfilled">{t(status)}</Box>;
          break;      
      default:
          orderStatusBox = <Box className="orderStatusBoxFulfilled">{t(status)}</Box>;
          break;
  }

  return orderStatusBox;
};


  const listOrders = () => {

    setIsLoading(true);

    const requestPayLoad = {

        orderBy       : orderBy,
        orderByType   : orderByType,
        filterBy      : filterBy,
        searchBy      : searchBy,
        paymentStatus : paymentStatus,
        orderStatus   : orderStatus,
        timePeriod    : timePeriod,
        searchByValue : searchByValue,
        pageSelected  : pageSelected

    };
   
    axios({
      
          url     : baseUrl+"/order/list",
          method  : "POST",
          data    : requestPayLoad,
          headers : {
            Authorization   : bearerToken,
            function        : Config.FUNCTION_KEY
          },
        
        }).then(function (response) 
        {
       

            const responseData           = response.data;
            const responseDataStatusCode = response.data.status;
            const responseStatusCode     = response.status;

            if(responseStatusCode === 200)
            {
                setIsLoading(false);

                if(responseDataStatusCode === 0)
                {
                    toast.error(t(response.data.message));
                    return;    
                }
                else if(responseDataStatusCode === 1 && responseData.data && responseData.data.rows)
                {
                    const columns  =  [
                      { Header: `${t("Order ID")}`, accessor: "vendorOrderID", align: "left"},
                      { Header: `${t("Store Order ID")}`, accessor: "storeOrderID", align: "left" },
                      { Header: `${t("Price")}`, accessor: "totalPrice", align: "right"},
                      { Header: `${t("Payment Mode")}`,accessor: "paymentMode", align: "left" },
                      { Header: `${t("Payment Status")}`, accessor: "paymentStatus", align: "left" },
                      { Header: `${t("Order Status")}`, accessor: "orderStatus", align: "left" },
                      { Header: `${t("Date")}`, accessor: "date", align: "left" },
                      { Header: `${t("Action")}`, accessor: "action", align: "left" }
                    ];
                   
                    
                    var rows = [];
                    
                    
                    responseData.data.rows.map((item, index) => {

                        let paymentStatusBox;
                        let orderStatusBox;

                        if(item.orderStatus === null)
                        item.orderStatus = 'unfulfilled';

                        orderStatusBox =getOrderStatusBox(item.orderStatus);

                        paymentStatusBox =getPaymentStatusBox(item.paymentStatus);

                        var tempData = {
                          "vendorOrderID"     : item.vendorOrderID,
                          "storeOrderID"      : <Box>{"#"+item.storeOrderID}</Box>,
                          "totalPrice"        : item.totalPrice.toFixed(2),
                          "paymentMode"       : <Box className="paymentModeBox">{item.paymentMode}</Box>,
                          "paymentStatus"     : paymentStatusBox,
                          "orderStatus"       : orderStatusBox,
                          "date"              : item.date,
                          "action"            : <Link onClick={(event) => { event.preventDefault(); navigate("/order/details/"+item.vendorOrderID) }}><Box className="squareBoxView"><VisibilityIcon color="primary" fontSize="medium" titleAccess={t("View")} /></Box></Link>,
                        };
                        
                        
                      rows.push(tempData);



                    });

                    setDataTableData({ columns, rows });
                    setResponseResultCount(responseData.data.totalCount);
                }

            }        

        }).catch(function (error) {

          handleErrors(error, t, navigate);
      

        });
      
  }
   
  
  return (
      <DashboardLayout>
        <DashboardNavbar pageTitle={t('orders')} />

        {isLoading ? (
            <Backdrop sx={{ color: '#FFFFFF', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
              <CircularProgress color="inherit" />
            </Backdrop>
        ) : <></> }

        <MDBox pt={6} pb={3}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card>
                <MDBox mx={2} className="ManageProductTopSec" mt={0} py={4} px={2} pb={1} variant="gradient">
                  <Grid container className="FilterSectionBox ManageProductContainer" spacing={2} 

                    sx={filterBy !== "none" && searchBy !== "none" ? { justifyContent: 'center' } : {}}
                  >
    
              <Grid item className="FilterSectionInnerBox" md={2} sm={3} xs={6}>
                <FormControl className='formcontrolFilterStyle'>
                  {renderFilterByList}
                  <Icon className='keyboardArrowDown'>keyboard_arrow_down</Icon>
                </FormControl>
              </Grid>

            {filterBy === "payment" ?
              <Grid item className="FilterSectionInnerBox" md={2} sm={3} xs={6}>
                <FormControl className='formcontrolFilterStyle'>
                  {renderPaymentStatusList}
                  <Icon className='keyboardArrowDown'>keyboard_arrow_down</Icon>
                </FormControl>
              </Grid>  
            : <></>}

            {filterBy === "order" ?
            <Grid item className="FilterSectionInnerBox" md={2} sm={3} xs={6}>
              <FormControl className='formcontrolFilterStyle'>
                {renderOrderStatusList}
                <Icon className='keyboardArrowDown'>keyboard_arrow_down</Icon>
              </FormControl>
            </Grid> 
            : <></>}

            {filterBy === "date" ?
            <Grid item className="FilterSectionInnerBox" md={2} sm={3} xs={6}>
              <FormControl className='formcontrolFilterStyle'>
                {renderTimePeriodList}
                <Icon className='keyboardArrowDown'>keyboard_arrow_down</Icon>
              </FormControl>
            </Grid> 
            : <></>}

            <Grid item className="FilterSectionInnerBox" md={2} sm={3} xs={6}>  
              <FormControl className='formcontrolFilterStyle'>
                {renderSearchByList}
                <Icon className='keyboardArrowDown'>keyboard_arrow_down</Icon>
              </FormControl>
            </Grid> 

            {(searchBy === "orderid") ?
              <Grid item className="FilterSectionInnerBox" md={2} sm={3} xs={6}>  
                <FormControl className='formcontrolFilterStyle'>                  
                  <InputLabel className='SearchInputHead'>{t('Search Input')}</InputLabel>
                  
                  
                  <MDInput
                    key={'searchValue'}
                    value={searchByValue}
                    type="text"
                    name="searchByValue"
                    InputProps={{
                        classes: { root: "filterStyle" },
                    }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    onChange={handleChangeSearchByValue}
                    onKeyPress={handleKeyPressSearchByValue}    
                    fullWidth />
                  
                </FormControl>
              </Grid> 
              :<></>
            }

            <Grid item className="FilterSectionInnerBox" md={2} sm={3} xs={6}>
                <FormControl className='formcontrolFilterStyle'>
                  {renderOrderByList}
                  <Icon className='keyboardArrowDown'>keyboard_arrow_down</Icon>
                </FormControl>
            </Grid>  

            <Grid item className="FilterSectionInnerBox" md={2} sm={3} xs={6}>
              <FormControl className='formcontrolFilterStyle'>
                {renderOrderByType}
                <Icon className='keyboardArrowDown'>keyboard_arrow_down</Icon>
              </FormControl>
            </Grid>

            <Grid item className="displyFlex FilterSectionInnerBox" md={2} sm={3} xs={6} >  
              <FormControl className='formcontrolFilterStyle'>
                  <MDButton 
                    color="info"
                    size="small"
                    disabled={isLoading}
                    disableRipple
                    onClick={() => {

                      navigate( "/order/list" );

                      if(typeof pageNo === "undefined")
                      listOrders();
                    }}
                  >{t('Submit')}
                </MDButton>
              </FormControl>   
              
              
              {isOrderContextChanged && (
              <FormControl className='formcontrolFilterStyle'>
                          <MDButton onClick={handleResetFilters} key="reset" type="submit" color="info" size="small" className="ResetButton" disableRipple fullWidth>{t('reset')}</MDButton>
                       </FormControl>     )}
              

                       

            </Grid> 
          </Grid>
          </MDBox>
          <MDBox pt={3}>
            {dataTableData.columns && dataTableData.columns.length > 0 ?
              <DataTable 
                table={dataTableData} 
                isSorted={false}
                showTotalEntries={true}
                responseResultCount={responseResultCount}
                paginationSize = { paginationSize }
                paginationLink = {"/order/list/page-"}
                pageSelected = {pageSelected}
              />
            : <></>}
          </MDBox>
          </Card>
        </Grid>
        </Grid>
        </MDBox>
      </DashboardLayout>
  );
}

export default List;
